import { useRef, useState } from 'react';
import { useOutsideAlerter } from '../../hooks';
import { ReactComponent as ArrowDown } from '../../assets/svg/ArrowDown.svg';

interface FormEntryStatusProps {
    value: boolean | null,
    editable?: boolean,
    setValue?: (v: boolean | null) => void
}

function FormEntryStatus({ value, editable, setValue }: FormEntryStatusProps) {
    const [isExpand, setIsExpand] = useState(false);
    const wrapperRef = useRef(null);

    useOutsideAlerter(wrapperRef, setIsExpand);

    return (
        <div
            className="form__entry-status"
            ref={wrapperRef}
            onClick={() => {
                if (!editable) return;
                setIsExpand(!isExpand);
            }}
        >
            <div className={'entry-status-list' + (isExpand ? ' _open' : '') + (editable ? '' : ' _disabled')}>
                <div className="entry-status-list__body">
                    <div className={'entry-status-list__item' + (value === null ? ' _active' : '')} onClick={() => setValue && setValue(null)}>
                        <span className="entry-status-list__icon _pending"></span>
                    </div>
                    <div className={'entry-status-list__item' + (value === true ? ' _active' : '')} onClick={() => setValue && setValue(true)}>
                        <span className="entry-status-list__icon _ok"></span>
                    </div>
                    <div className={'entry-status-list__item' + (value === false ? ' _active' : '')} onClick={() => setValue && setValue(false)}>
                        <span className="entry-status-list__icon _rejected"></span>
                    </div>
                </div>
                <div className="entry-status-list__arrow">
                    <ArrowDown />
                </div>
            </div>
        </div>
    )
}

export default FormEntryStatus;